var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M125.312 36.7642V88.7202C125.312 106.142 117.315 118.108 103.241 122.634C99.1485 124.06 94.4365 124.742 89.2905 124.742H37.3345C32.1885 124.742 27.4765 124.06 23.3845 122.634C9.31048 118.108 1.3125 106.142 1.3125 88.7202V36.7642C1.3125 14.1962 14.7665 0.742188 37.3345 0.742188H89.2905C111.859 0.742187 125.312 14.1962 125.312 36.7642Z",
    fill: "url(#paint0_radial_17527_95269)",
    stroke: "url(#paint1_linear_17527_95269)",
    strokeWidth: 1.16279
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.878 113.65C103.397 118.557 99.9545 124.057 94.4602 124.547C92.9415 124.682 91.3747 124.749 89.7654 124.749H37.8094C36.2001 124.749 34.6333 124.682 33.1145 124.547C27.6203 124.057 24.1781 118.557 26.6969 113.65C32.7559 101.846 47.12 93.5625 63.7874 93.5625C80.4547 93.5625 94.8189 101.846 100.878 113.65Z",
    fill: "url(#paint2_radial_17527_95269)",
    stroke: "url(#paint3_linear_17527_95269)",
    strokeWidth: 1.16279
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1576 60.1336C85.1576 72.4096 75.2376 82.3914 62.9616 82.3914C50.6856 82.3914 40.7656 72.4096 40.7656 60.1336C40.7656 47.8576 50.6856 37.9375 62.9616 37.9375C75.2376 37.9375 85.1576 47.8576 85.1576 60.1336Z",
    fill: "url(#paint4_radial_17527_95269)",
    stroke: "url(#paint5_linear_17527_95269)",
    strokeWidth: 1.16279
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17527_95269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3125 62.7422) rotate(90) scale(122.967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17527_95269",
    x1: 11.1761,
    y1: 5.90886,
    x2: 83.6669,
    y2: 146.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_17527_95269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.7874 109.156) rotate(90) scale(30.9263 79.1906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17527_95269",
    x1: 30.2116,
    y1: 94.8619,
    x2: 38.8784,
    y2: 137.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_17527_95269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9616 60.1644) rotate(90) scale(44.0834 44.0221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17527_95269",
    x1: 44.2968,
    y1: 39.7897,
    x2: 70.3056,
    y2: 90.0735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.4d4d0acbc72596f2e357a4e14fefd170.svg";
export { ForwardRef as ReactComponent };